import { ApplicationInsights } from "@microsoft/applicationinsights-web";

var TELEMETRY_GIDS = {
  "5d46a893-e321-4f85-a8bd-b30400535985": true,
  "ca6f18bc-c995-467e-8d88-b2bf01284b9e": true,
};

var appInsightsClient = null;

function sanitizeTelemetryProperties(properties) {
  var sanitized = {};
  if (!properties) return sanitized;

  for (var key in properties) {
    if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;

    var value = properties[key];
    if (value === undefined || value === null) {
      sanitized[key] = "";
      continue;
    }

    if (typeof value === "object") {
      try {
        sanitized[key] = JSON.stringify(value);
      } catch (err) {
        sanitized[key] = String(value);
      }
      continue;
    }

    sanitized[key] = String(value);
  }

  return sanitized;
}

export function shouldTrackTelemetryByGid(gid) {
  return !!TELEMETRY_GIDS[String(gid || "")];
}

export function getApplicationInsightsClient() {
  if (appInsightsClient) return appInsightsClient;

  try {
    appInsightsClient = new ApplicationInsights({
      config: {
        connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
        enableAutoRouteTracking: false,
      },
    });
    appInsightsClient.loadAppInsights();
    return appInsightsClient;
  } catch (err) {
    console.warn("Application Insights initialization failed", err);
    return null;
  }
}

export function trackAppInsightsEvent(eventName, properties, gid) {
  if (!eventName || !shouldTrackTelemetryByGid(gid)) {
    return false;
  }

  var client = getApplicationInsightsClient();
  if (!client) return false;

  var mergedProperties = sanitizeTelemetryProperties({
    gid: String(gid || ""),
    host: window.location.host,
    href: window.location.href,
    timestamp: new Date().toISOString(),
    ...(properties || {}),
  });
  //console.log("AppInsights event:", eventName, mergedProperties);
  try {
    client.trackEvent(
      {
        name: eventName,
      },
      mergedProperties,
    );
    return true;
  } catch (err) {
    console.warn("Application Insights trackEvent failed", err);
    return false;
  }
}
